import type { ISignupLocale } from '@/Pages/Onboard/SignUp/Locale/Signup.locale';

const esES: ISignupLocale = {
  title: 'Crea tu cuenta de {brand}',
  subtitle: 'Únete a nosotros e inicia tu viaje con análisis poderosos.',
  firstName: {
    label: 'Nombre',
    placeholder: 'Ingresa tu nombre',
    error: 'El nombre es obligatorio',
  },
  lastName: {
    label: 'Apellido',
    placeholder: 'Ingresa tu apellido',
    error: 'El apellido es obligatorio',
  },
  email: {
    label: 'Dirección de Email',
    placeholder: 'Ingresa tu dirección de email',
    error: 'La dirección de email es obligatoria',
    invalidError: 'Por favor, ingresa una dirección de email válida',
  },
  password: {
    label: 'Contraseña',
    placeholder: 'Crea una contraseña fuerte',
    error:
      'La contraseña debe tener al menos 8 caracteres con mayúscula, minúscula, número y carácter especial',
    validationTitle: 'La contraseña debe contener:',
    validationMinLength: 'Al menos 8 caracteres',
    validationUppercase: 'Al menos una letra mayúscula',
    validationLowercase: 'Al menos una letra minúscula',
    validationNumber: 'Al menos un número',
    validationSpecialChar: 'Al menos un carácter especial',
  },
  confirmPassword: {
    label: 'Confirmar Contraseña',
    placeholder: 'Confirma tu contraseña',
    error: 'Por favor, confirma tu contraseña',
    mismatchError: 'Las contraseñas no coinciden',
  },
  button: {
    signup: 'Crear Cuenta',
    signingUp: 'Creando Cuenta...',
  },
  terms: {
    prefix: 'Al crear una cuenta, aceptas nuestros',
    terms: 'Términos de Servicio',
    and: 'y',
    privacy: 'Política de Privacidad',
    suffix: '.',
  },
  success: {
    title: '¡Cuenta creada exitosamente!',
    message: '¡Bienvenido a Sonarprint! Revisa tu email para verificar tu cuenta.',
  },
  backToLogin: {
    text: '¿Ya tienes una cuenta? Iniciar sesión',
    link: 'Iniciar sesión',
  },
};

export { esES };
